exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.Form-Form_271Cj {\n  margin-top: 1rem; }\n  .Form-Form_271Cj > * + * {\n    margin-top: 1rem; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Form/Form/Form.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,iBAAiB,EAAE;EACnB;IACE,iBAAiB,EAAE","file":"Form.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.Form {\n  margin-top: 1rem; }\n  .Form > * + * {\n    margin-top: 1rem; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Form": "Form-Form_271Cj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/Form/Form/Form.scss
// module id = 1283
// module chunks = 0